import React, { useEffect, useState, useRef } from 'react'
import { useSearchParams } from 'react-router-dom';
import Functions from './function';
import Logo from '../../../images/public/websitefooter.png'
import { formatDate } from '../../../configTools/dateFormat'

const Index = () => {
    const [searchParams] = useSearchParams();
    const [formData,setFormData] = useState(null);
    const inprint = useRef(false);
    useEffect(()=>{
        Functions.Get(searchParams.get('from'),searchParams.get('to'),(data)=>{
            setFormData(data)
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[searchParams])
  return (
    <>
        <div style={{width:"200px",margin:"20px auto"}}>
            <img src={Logo} style={{width:"100%"}} alt="N-Vision Dental"/>
        </div>
      {formData &&
      <>
        <div style={{display:"flex",justifyContent:"space-between"}}>
            <h3 style={{fontWeight:"500",fontSize:"18px"}}>Sales of date range</h3>
            <p>From: {formatDate(searchParams.get('from'))} To: {formatDate(searchParams.get('to'))}</p>
        </div>
        <div style={{backgroundColor:"#2F1C60",height:"5px",margin:"10px 0px"}}></div>
        <div style={{display:"flex",border:"1px solid black"}}>
            <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Invoice</h3>
            </div>
            <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Doctor</h3>
            </div>
            <div style={{width:"30%", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>Amount</h3>
            </div>
        </div>
        {formData.list.map((item,index)=>{
            return(
                <div key={index} style={{display:"flex",borderBottom:"1px solid black",borderLeft:"1px solid black",borderRight:"1px solid black"}}>
                    <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500"}}>OR{item.id}</h3>
                    </div>
                    <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500"}}>{item.doctorname}</h3>
                    </div>
                    <div style={{width:"30%", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>{item.nettotal}</h3>
                    </div>
                </div>
            )
        })}
        <div style={{display:"flex",borderBottom:"1px solid black",borderLeft:"1px solid black",borderRight:"1px solid black"}}>
            <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                <div style={{fontSize:"16px",fontWeight:"500"}}></div>
            </div>
            <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Total</h3>
            </div>
            <div style={{width:"30%", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>{formData.closingbalance}</h3>
            </div>
        </div>
      </>
      }
    </>
  )
}

export default Index
